import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import awbRemote from '../../api/awbRemote';
import cartRemote from '../../api/cartRemote';

import { receiveError } from '../../store/actions/notificationAction';
import { updateWholeCart } from '../../store/actions/cartAction';
import { fetchFinish, fetchPending } from '../../store/actions/fetchingAction';
import { setDestinationGha, setOriginGha }  from '../../store/actions/ghaAction';
import { receiveAwbs, receiveExportAwbs, receiveGhaAwbs } from '../../store/actions/awbsAction';
import { receivePorts, setDestinationPort, setOriginPort } from '../../store/actions/portAction';

import GhaHeader from '../gha/ghaHeader/GhaHeader';
import ForwarderHeader from './ForwarderHeader';
import GhaInfoContainer from '../forwarderImport/ghaInfo/GhaInfoContainer';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import GhaManualEntryHeader from '../gha/manageOrders/manualEntry/headers/GhaManualEntryHeader';
import AddImportAWBModalContainer from '../forwarderImport/addAWBModal/AddAWBModalContainer';
import AddExportAWBModalContainer from '../forwarderExport/addAWBModal/AddAWBModalContainer';
import ForwarderHeaderInvoiceBalanceContainer from '../forwarderHeaderInvoiceBalance/ForwarderHeaderInvoiceBalanceContainer';

import Awb from '../../models/Awb';
import Ports from '../../models/Ports';
import User, { UserRoleType } from '../../models/User';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { AwbPartStatuses } from '../../models/AwbPart';
import GhaHeaderOptionsModel from '../../models/GhaHeaderOptions';

import forwarderStyles from './forwarderHeader.module.css';

import { AWB_SCHEMA } from '../../utils/airwayBill';
import validation from '../../utils/validation';
import PoDModalContainer from '../poD/PoDModalContainer';
import AwbHistory from './AwbHistory';
import ConfirmAwb from './ConfirmAwb';
import ManualAwbConfirmModal from './ManualAwbConfirmModal';
import LocationConfirmModal from '../common/LocationConfirmModal';
import AwbBasic from '../../models/AwbBasic';

interface HeaderState {
  awb: string;
  importModalOpen: boolean;
  exportModalOpen: boolean;
  awbData: Awb;
  ghas: Array<GhaHeaderOptionsModel>;
  manualOpen: boolean;
  requestId: string;
  manualEntry: boolean;
  modalAwbInTheListOfGhaOpen: boolean;
  isModalPoDOpen: boolean;
  awbsHistoryModal: boolean;
  confirmAwbModal: boolean;
  awbsInfo: any;
  confirmAwbText: string;
  confirmError: boolean;
  refreshDisable: boolean;
  selectedAwb: Awb;
  version: number;
  disableButton: boolean;
  locationConfirmModal: boolean;
  awbInfo: AwbBasic;
  forceExtract: boolean;
  manualConfirmModalOpen: boolean;
  manualConfirmAwbData: Awb | null;
  manualConfirmOpts: { edit: boolean, metadata: boolean } | null;
};

interface HeaderProps { 
  ports: Ports;
  port: string;
  ghaId: number;
  availableAwbPartStatuses: AwbPartStatuses;
  getPorts: Function;
  onReceiveAwbs: Function;
  onReceiveGhaAwbs: Function;
  onReceiveExportAwbs: Function;
  receiveError: Function;
  fetchFinish: Function;
  fetchPending: Function;
  setDestinationPort: Function;
  setOriginPort: Function;
  setDestinationGha: Function;
  setOriginGha: Function;
  type: 'import' | 'export';
  userRole : UserRoleType;
  operation: string;
  ghaUserId: number;
  ghaAwbs: Array<Awb>;
  isMeEditMode: boolean;
  user: User;
  isGoOrder?: boolean;
  updateCart: Function;
};

class HeaderContainer extends Component <HeaderProps, HeaderState> {
  state = {
    ghas: [],
    awb: '',
    importModalOpen: false,
    exportModalOpen: false,
    manualOpen: false,
    requestId: '',
    awbData: AWB_SCHEMA,
    manualEntry: false,
    modalAwbInTheListOfGhaOpen: false,
    isModalPoDOpen: false,
    awbsHistoryModal: false,
    confirmAwbModal: false,
    awbsInfo: [],
    confirmAwbText: '',
    confirmError: false,
    refreshDisable: true,
    selectedAwb: {} as Awb,
    version: 0,
    disableButton: false,
    locationConfirmModal: false,
    awbInfo: {} as AwbBasic,
    forceExtract: false,
    manualConfirmModalOpen: false,
    manualConfirmAwbData: null,
    manualConfirmOpts: null
  };

  handleChange = (name: string) => (event: any): void => {
  
    switch(name) {
      case 'port': 
        const port = event.target.value;
        const ghas = this.props.ports[port];
        const gha = ghas[0].id;
        if (this.props.type === 'import') {
          this.props.setDestinationPort(port);
          this.props.setDestinationGha(gha);
        } else {
          this.props.setOriginPort(port);
          this.props.setOriginGha(gha);
        }
        this.setState({ ghas });        
        break;
      case 'gha': 
        const gha_id = event.target.value;
        if (this.props.type === 'import') {
          this.props.setDestinationGha(gha_id);
        } else {
          this.props.setOriginGha(gha_id);
        }
        break;
      // case 'confirm': 
        
      // break;
      case 'awb': 
        let value: string = event.target.value;

        if (value.length === 3 && this.state.awb.length === 2) {
          value = value + '-';
        }

        if (value.length === 11) {
          if (value.indexOf('-') < 0) {
            value = value.slice(0 , 3) + '-' + value.slice(3);
          }
        }

        if (value.split('-').length > 2) {
          return;
        }

        this.setState({ awb: value }); 
        break;

      default: break;
    }
  }

  changeText = (event: any): void => {
    let text = event.target.value;
    if (text.length === 3 && this.state.confirmAwbText.length === 2) {
      text = text + '-';
    }

    if (text.length === 11) {
      if (text.indexOf('-') < 0) {
        text = text.slice(0 , 3) + '-' + text.slice(3);
      }
    }

    if (text.split('-').length > 2) {
      return;
    }
    this.setState({ confirmAwbText: text });
  }

  handleClose = (modalType: string): void => {

    if (modalType === 'import') {
      this.setState({ importModalOpen: false, requestId: '' });
    } else if(modalType === 'pod') {
      this.setState({ isModalPoDOpen: false });
    } else if(modalType === 'history') {
      this.setState({ awbsHistoryModal: false, selectedAwb: {} as Awb });
    } else if(modalType === 'confirm') {
      this.setState({ confirmAwbModal: false, confirmAwbText: '', confirmError: false });
    } else if(modalType === 'manualConfirm') {
      this.setState({ manualConfirmModalOpen: false, manualConfirmAwbData: null, manualConfirmOpts: null });
    } else {
      this.setState({ exportModalOpen: false, requestId: '' });
    }
  }


  fetchAwbs = (): void => {
    if (validation.validateAWB(this.state.awb)) {
      awbRemote.getAwbs(this.state.awb).then(resp => {
        const awbsInfo: any | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (error) {
          this.props.receiveError(error);
        }
        if (!awbsInfo.awbs.length) {
          this.addClicked()
        }

        if (awbsInfo.awbs.length) {
          this.setState({ awbsHistoryModal: true, awbsInfo: awbsInfo.awbs, refreshDisable: awbsInfo.refresh });
        }
      });
    }
  }

  confirmAwb = (type: string): void => {
    if(type == 'step1') {
      this.setState({ awbsHistoryModal: false, confirmAwbModal: true });
    } else if(type == 'step0') {
      this.addClicked('select');
    } else {
      if(this.state.confirmAwbText === this.state.awb) {
        this.addClicked('confirm');
      } else {
        this.setState({ confirmError: true });
      }
    }
  }
  
  setFocus = (): void => {
    let input = document.getElementById('awb');
    input && input.focus();
  }      

  clearAwb = () : void => {
    this.setState({ awb: '' });
  }

  addClicked = (type?: string): void => {
    let version: number | undefined = undefined;
    if(type == 'confirm') {
      this.setState({ confirmAwbModal: false, confirmAwbText: '', selectedAwb: {} as Awb });
    } else if(type == 'select') {
      version = this.state.selectedAwb.version;
    }
    
    this.setState({ manualEntry: false });

    if (validation.validateAWB(this.state.awb)) {

      if (this.props.userRole === UserRoleType.GHA) {
        const awbNumberArr: string[] = this.state.awb.split('-');
        const isAwbAdded: boolean = !!(this.props.ghaAwbs.find((awb: Awb) => awb.code === awbNumberArr[0] && awb.number === awbNumberArr[1]));
        
        if (isAwbAdded) {
          this.manipulateModalAwbInTheListOfGha(true);
          return;
        }
      }

      this.props.fetchPending();
      const isExport: boolean = this.props.type === 'export';
      awbRemote.extractNewAwb(this.state.awb, this.props.type, isExport, version, this.state.forceExtract).then((resp: { awbData: Awb, requestId: string }) => {
        this.setState({ 
          importModalOpen: this.props.type === 'import',
          exportModalOpen: isExport,
          awbData: resp.awbData,
          requestId: resp.requestId
        });

        this.props.fetchFinish();

      }, (err) => {
        this.props.fetchFinish();
        if (err.errorCode === '#couldntExtractAWBInfo' || err.errorCode === '#airwayCodeNotFound') {
          this.setState({
            manualOpen: true,
            awbData: AWB_SCHEMA,
            requestId: '',
            forceExtract: false
          });
        } else if (err.errorCode === '#incompatibleGhaForPortAirlne') {

          this.setState({ locationConfirmModal: true, awbInfo: err.data, forceExtract: false });
        }
        else if (err.errorCode === '#ExportAddedToImport') {

          this.setState({ awbInfo: err.data, confirmAwbModal: false, awbsHistoryModal: false });

          this.props.receiveError(err);
        }
        else {
          this.props.receiveError(err);
        }
      });
    } else {
      let errObj: ResponseError = {
        errorCode: '',
        longDescription: 'The entered value should contain a code (3 digits) and a number (8 digits) separated by a dash (-)!'
      }
      this.props.receiveError(errObj);
    }
  }

  isDisabled = (): boolean => {
    if (this.state.awb !== '') {
      return false;
    };
    return true;
  }

  handleOpenPoD = (code: string, number: string, version: number): void => {

    this.setState({ isModalPoDOpen: true, version });
  };

  handleKeyDown = (event: any): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.fetchAwbs();
    }
  }

  selectAwb = (awb: Awb): void => {
    this.setState({ selectedAwb: awb });
  }

  handleSave = (awbData: Awb, opts: { edit: boolean, metadata: boolean}): void => {
    this.proceedHandleSave(awbData, opts, false);
  }

  proceedHandleSave = (awbData: Awb, opts: { edit: boolean, metadata: boolean}, confirmInterline: boolean = false): void => {
    const isExport: boolean = this.props.type === 'export';
    const version = this.state.selectedAwb && this.state.selectedAwb.version ? this.state.selectedAwb.version : awbData && awbData.version ? awbData.version : undefined;

    awbRemote.addAwbList(awbData, opts.edit, isExport, this.state.requestId, undefined, version, confirmInterline).then((resp: ApiResponse<Awb>) => {

      this.handleClose('history');
      const awb: Awb | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awb) {
        if (this.props.userRole === UserRoleType.FORWARDER) {
          const port: string = this.props.type === 'import' ? awb.destination : awb.origin;
          const gha: number | null = this.props.type === 'import' ? awb.id_gha_dst : awb.id_gha_org;

          if (this.props.port === port && this.props.ghaId === gha) {

            if (this.props.type === 'import') {
              this.props.onReceiveAwbs(port, gha);
            } else {
              this.props.onReceiveExportAwbs(port, gha);
            }
          } else if (port && gha) {

            this.loadPorts();

          if (this.props.type === 'import') {
            this.props.setDestinationPort(port);
            this.props.setDestinationGha(gha);
          } 

          if (this.props.type === 'export') {
            this.props.setOriginPort(port);
            this.props.setOriginGha(gha);
          }
        }
      } 

      if(this.props.userRole === UserRoleType.GHA) {
        const isExport: boolean = !!(this.props.type === 'export')
        this.props.onReceiveGhaAwbs(isExport);
      }

        this.setState({ 
          importModalOpen: false, 
          exportModalOpen: false,
          manualConfirmModalOpen: false,
          manualConfirmAwbData: null,
          manualConfirmOpts: null,
          requestId: ''
        });    
      }

      // Handle custom error codes
      if (error && error.errorCode === '#awbCodeNotHandledByGhaButAirlineIs') {
        this.setState({
          manualConfirmModalOpen: true,
          manualConfirmAwbData: awbData,
          manualConfirmOpts: opts
        });
      } else if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleManualConfirmProceed = (): void => {
    if (this.state.manualConfirmAwbData && this.state.manualConfirmOpts) {
      this.proceedHandleSave(this.state.manualConfirmAwbData, this.state.manualConfirmOpts, true);
    }
  };

  handleManualYes = (): void => {

    const awb = this.state.awb.split('-');

    this.setState({
      awbData: {
          ...this.state.awbData,
          code: awb[0],
          number: awb[1]
      },
      importModalOpen: this.props.type === 'import',
      exportModalOpen: this.props.type === 'export',
      manualOpen: false,
      manualEntry: true,
      requestId: ''
    });
  }

  loadPorts = (): void => {
    if(this.props.userRole === UserRoleType.FORWARDER) {
      if (this.props.type === 'import') {
        this.props.getPorts('dst');
      } else {
        this.props.getPorts('org');
      }
    }
  }

  confirmAccess = (): void => {
    this.setState({ forceExtract: true, locationConfirmModal: false }, () => {
      this.addClicked();
    });
  }

  public componentDidMount() {
    if(this.props.user.roleName === 'GHA Manager' || this.props.user.roleName === 'GHA Supervisor') {
      this.setState({ disableButton: true });
    } 
    this.loadPorts();
  }

  componentDidUpdate(prevProps: HeaderProps) {
    const newProps: HeaderProps = this.props;
    let portsArr: Array<string> = [];

    if (prevProps.type !== newProps.type) {
      this.loadPorts();
    }
    this.setFocus();
    portsArr = Object.keys(this.props.ports);

    if (prevProps.ports !== newProps.ports) {
      if (portsArr.length > 0) { 
        if (this.props.port === '') {
          const port: string = portsArr[0];
          const ghas: Array<GhaHeaderOptionsModel> = this.props.ports[port];
          const gha: number = ghas[0].id;

          if (this.props.type === 'import') {
            this.props.setDestinationPort(port);
            this.props.setDestinationGha(gha);
          }

          if (this.props.type === 'export') {
            this.props.setOriginPort(port);
            this.props.setOriginGha(gha);
          }

          this.setState({ ghas });         
        }  else {
          const ghas: Array<GhaHeaderOptionsModel> =  this.props.ports[this.props.port];
          this.setState({ ghas });
        }      
      } else {
        this.setState({ ghas: [] });
      }
    }
  }

  manipulateModalAwbInTheListOfGha = (isModalOpen: boolean): void => {
      this.setState({ modalAwbInTheListOfGhaOpen: isModalOpen });
  }

  render() {
    
    const containerWrapperClassName: string = this.props.userRole === UserRoleType.FORWARDER
      ? forwarderStyles.containerWrapperFwd
      : (this.props.operation === 'manual' ? forwarderStyles.containerWrapperGhaManual : forwarderStyles.containerWrapperGhaNotManual);

    return (
      <Fragment>
        <div className={ containerWrapperClassName }>
        { this.props.userRole === UserRoleType.FORWARDER &&
          <ForwarderHeader
            ports={ this.props.ports }
            ghaValue={ this.props.ghaId }
            portValue={ this.props.port }
            ghas={ this.state.ghas }
            handleChange={ this.handleChange }
            handleKeyDown={ this.handleKeyDown }
            addClicked={ this.fetchAwbs }
            isDisabled={ this.isDisabled }
            awbValue={ this.state.awb }
          />
        }
        { !this.props.isMeEditMode && this.props.userRole === UserRoleType.GHA && this.props.operation === 'manual' &&
           <GhaManualEntryHeader
            awbValue={ this.state.awb }
            handleChange={ this.handleChange }
            addClicked={ this.fetchAwbs }
            isDisabled={ this.isDisabled }
            handleKeyDown={ this.handleKeyDown }
          />
        }
        { this.props.userRole === UserRoleType.GHA && this.props.operation === 'not-manual' &&
          <GhaHeader ghaId={ this.props.ghaUserId } type={ this.props.type }></GhaHeader>
        }
        { (this.props.ghaId !== -1 && this.props.userRole === UserRoleType.FORWARDER) &&
          <div className={ forwarderStyles.forwarderWrap }>
            { this.props.type === 'import' && <ForwarderHeaderInvoiceBalanceContainer /> }
            <GhaInfoContainer ghaId={this.props.ghaId } type={ this.props.type }/>
          </div>
        }
        </div>
        { this.state.importModalOpen &&
          <AddImportAWBModalContainer 
            modalOpen={ this.state.importModalOpen }
            awb={ this.state.awbData }
            handleSave={ this.handleSave }
            handleCloseModal={ this.handleClose }
            awbActionOfUpdateButton={ 'add' }
            manualEntry={ this.state.manualEntry }
            handleOpenPoD={ this.handleOpenPoD }
            clearAwb={ this.clearAwb }
          />
        }
        { this.state.exportModalOpen &&
          <AddExportAWBModalContainer 
            modalOpen={ this.state.exportModalOpen }
            awb={ this.state.awbData }
            handleSave={ this.handleSave }
            handleCloseModal={ this.handleClose }
            awbActionOfUpdateButton={ 'add' }
            edited={ true }
            manualEntry={ this.state.manualEntry }
            userRole={ this.props.userRole }
            clearAwb={ this.clearAwb }
          />
        }
        { this.state.manualOpen &&
          <ConfirmationDialog
            open={ this.state.manualOpen }
            title='This AWB cannot be found!'
            text='Do you want to add it manually?'
            close={() => { this.setState({ manualOpen: false }) }}
            confirm={ this.handleManualYes }
            textConfirm='yes'
            showCloseIcon={ true }
          /> 
        }

        { this.state.modalAwbInTheListOfGhaOpen &&
          <ConfirmationDialog
            open={ this.state.modalAwbInTheListOfGhaOpen }
            title='Error'
            text='This AWB is already added to the list!'
            close={ () => this.manipulateModalAwbInTheListOfGha(false) }
            confirm={ () => this.manipulateModalAwbInTheListOfGha(false) }
            textConfirm='ok'
            showCloseIcon={ true }
          /> 
        }
        { this.state.isModalPoDOpen && 
         <PoDModalContainer 
            isModalOpen={ this.state.isModalPoDOpen }
            handleCloseModal={ this.handleClose }
            code={ this.state.awb.split("-")[0] }
            number={ this.state.awb.split("-")[1]  }
            version={ this.state.version }
          />
        }
        { this.state.awbsHistoryModal && 
         <AwbHistory 
            modalOpen={ this.state.awbsHistoryModal }
            handleClose={ this.handleClose }
            awbHistory={ this.state.awbsInfo }
            proceed={ this.confirmAwb }
            refreshDisable={ this.state.refreshDisable }
            selectedAwb={ this.state.selectedAwb }
            selectAwb={ this.selectAwb }
            type={ this.props.type }
          />
        }

        { this.state.confirmAwbModal && 
         <ConfirmAwb 
            modalOpen={ this.state.confirmAwbModal }
            handleClose={ this.handleClose }
            awbText={ this.state.confirmAwbText }
            proceed={ this.confirmAwb }
            handleChangeText={ this.changeText }
          />
        }
        {
          this.state.locationConfirmModal && 
          <LocationConfirmModal
            modalOpen={ this.state.locationConfirmModal }
            handleClose={ () => { this.setState({ locationConfirmModal: false }) } }
            confirm={ this.confirmAccess }
            awbData={ this.state.awbInfo }
            disableBtn={ this.state.disableButton }
          />
        } 
        { this.state.manualConfirmModalOpen &&
          <ManualAwbConfirmModal
            modalOpen={ this.state.manualConfirmModalOpen }
            originalAwbText={ `${this.state.awbData.code}-${this.state.awbData.number}` }
            handleClose={ () => this.handleClose('manualConfirm') }
            proceed={ this.handleManualConfirmProceed }
            isImport={ this.props.type === 'import' }
          />
        }
      </Fragment>
    );
  };
};

const mapStateToProps = (state: any, props: any) => {
  return {
    ports: props.type === 'import'? state.destinationPorts : state.originPorts,
    port: props.type === 'import'? state.destinationPort : state.originPort,
    ghaId: props.type === 'import'? state.destinationGhaId : state.originGhaId,
    availableAwbPartStatuses: state.awbPartStatuses,
    ghaUserId: state.user.gha_id,
    ghaAwbs: state.awbsGha,
    isMeEditMode: state.manualEntryEdit.isEditMode,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any, props: any) => {

  return {
    getPorts: (direction: 'org' | 'dst') => dispatch(receivePorts(direction)),
    onReceiveAwbs: (port: string, gha: number) => dispatch(receiveAwbs(port, gha)),
    onReceiveExportAwbs: (port: string, gha: number) => dispatch(receiveExportAwbs(port, gha)),
    onReceiveGhaAwbs: (isExport: boolean) => dispatch(receiveGhaAwbs(isExport)),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    fetchFinish: () => dispatch(fetchFinish()),
    fetchPending: () => dispatch(fetchPending()),
    setDestinationPort: (port: string) => dispatch(setDestinationPort(port)),
    setOriginPort: (port: string) => dispatch(setOriginPort(port)),
    setDestinationGha: (gha: number) => dispatch(setDestinationGha(gha)),
    setOriginGha: (gha: number) => dispatch(setOriginGha(gha)),
    updateCart: (cartResponse: any) => dispatch(updateWholeCart(cartResponse))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderContainer));